<h2 mat-dialog-title>{{ 'txScheduler.warnings.no-multiple-fzs-title' | translate }}</h2>
<mat-dialog-content>
    <p>{{ 'txScheduler.warnings.no-multiple-fzs-text' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="onClose()">
        {{ 'general.abort' | translate }}
    </button>
</mat-dialog-actions>
